module.exports = __webpack_public_path__ + "static/media/_ARK2885_1.459f1fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cafeteria/_ARK2885_1.jpg
// module id = 1143
// module chunks = 0